import { withStyles } from "@material-ui/core/styles";
import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import Snackbar from "../snackbar";
import { emotionStyle } from "./style";

export class Emotion extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes, data } = this.props;
    let keys = Object.keys(data);
    let values = Object.values(data);
    return (
      <div>
        <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
        <div className={classes.container}>
          {keys.map((element, index) => {
            let src = "/images/icon/" + element + ".svg";
            return (
              <div className={classes.containerEmotion}>
                <div className={classes.containerIconEmotion}>
                  <img className={classes.iconEmotion} src={src} alt="edit" />
                </div>
                <div className={classes.countEmotion}>{values[index]}</div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({
  npsDispatch: dispatch.nps,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(withStyles(emotionStyle, { withTheme: 0 })(Emotion))
);
